export class GetGcsServiceAgentResponse {
    'gcsServiceAgent';
    'scanningServiceAccount';
    'vaultServiceAccount';
    'restoreServiceAccounts';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcsServiceAgent",
            "baseName": "gcsServiceAgent",
            "type": "string",
            "format": ""
        },
        {
            "name": "scanningServiceAccount",
            "baseName": "scanningServiceAccount",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultServiceAccount",
            "baseName": "vaultServiceAccount",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreServiceAccounts",
            "baseName": "restoreServiceAccounts",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetGcsServiceAgentResponse.attributeTypeMap;
    }
    constructor() {
    }
}
